import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { BillForm } from '@/components/pages/Admin/BillManagement/Form/BillForm'
import { useGetBillById } from '@/modules/bill/services/bill'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/bill/$id/edit')({
  component: BillEditPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tab: (search.tab as string) || 'buy',
    }
  },
})

function BillEditPage() {
  const t = useTranslations('admin.bill_management.edit')
  const { id } = Route.useParams()
  const { tab } = Route.useSearch()
  const { data } = useGetBillById(id)

  if (!data) return null

  return (
    <HomeContentContainer title={t('title') + ` (${tab === 'buy' ? 'ซื้อ' : 'ขาย'})`} contentClassName="max-w-full">
      <BillForm action="edit" tab={tab} data={data} id={id} />
    </HomeContentContainer>
  )
}

